import React, { useState,useEffect } from 'react';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import downloadIcon from "../../../../Assets/icons/download.svg";
import "./bulkUpload.scss";
import axiosInstance from '../../../services/api/API';
import Swal from 'sweetalert2';

const BulkUpload = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [successRows, setSuccessRows] = useState([]); // Array to hold successful records
  const [failedRows, setFailedRows] = useState([]); // Array to hold failed records
  const [uploadedHeaders, setUploadedHeaders] = useState([]); // Array to hold uploaded file headers
  const token = localStorage.getItem('authToken');

  const [ masterOptions, setMasterOptions ] = useState([])
  const [ subMasterOptions, setSubMasterOptions ] = useState([])

  const [ masterMenuIdValue, setMasterMenuIdValue ] = useState(0) 
  const [responseMessage, setResponseMessage] = useState(''); // For success/error messages
  const [isError, setIsError] = useState(false); // To track if the message is an error or success


  const authToken = localStorage.getItem("authToken");

useEffect(() => {
masterDropdownData()
},[])

const masterDropdownData = async () => {
try{
  const response = await axiosInstance.get("/bulkupload/ddlmastermenu",{
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  })

  const data = response.data.data
  console.log(data, "MasterData")
  const masterOptions = data.map(masterData => ({
    value: masterData.menu_id,
    label:masterData.menu_name,
  }))
  setMasterOptions(masterOptions)

  console.log(masterOptions, "formdata")
 

}catch(error) {
  console.log(error)
}
}

useEffect(() => {
const masterIdValue = formData?.master;
setMasterMenuIdValue(masterIdValue); // Update state
console.log(masterIdValue, "MasterValueDataId");
if (masterIdValue) {
  subMasterDropdownData(masterIdValue); // Pass the masterIdValue directly to the function
}
}, [formData?.master]);


const subMasterDropdownData = async (masterMenuIdValue) => {
try{
  const response = await axiosInstance.get(`/bulkupload/ddlsubmastermenu/${masterMenuIdValue}`,{
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  })

  const data = response.data.data
  console.log(data, "MasterData")
  const subMasterOptionsData = data.map(masterData => ({
    value: masterData.menu_id,
    label:masterData.menu_name,
  }))
  setSubMasterOptions(subMasterOptionsData)
}catch(error) {
  console.log(error)
}
}

// const handleFormSubmit = async (formData) => {
//   const errors = {};
//   let isValid = true;

//   UploadInputs.forEach((field) => {
//     if (field.validation && field.validation.required) {
//       if (!formData[field.name]) {
//         errors[field.name] = "This field is required";
//         isValid = false;
//       } else if (
//         field.validation.pattern &&
//         !field.validation.pattern.test(formData[field.name])
//       ) {
//         errors[field.name] = field.validation.message;
//         isValid = false;
//       }
//     }
//   });

//   if (!isValid) {
//     setValidationErrors(errors);
//     return;
//   }
//   try {
//     const formDataToSend = new FormData();
//     formDataToSend.append('importFileUpload', formData.uploadDocument);
//         formDataToSend.append("masterMenuId",masterMenuIdValue)
//         formDataToSend.append("masterSubMenuId",formData.submaster)
//     console.log(formData, "uploadedDocument");

//     const response = await axiosInstance.post("/bulkupload/importBulk", formDataToSend, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//         Authorization: `Bearer ${authToken}`,
//       },
//     });

//     console.log(response.data, "UPLOADEDFile");

//     if (response.data.status === 200) {
//       const { success, errors } = response.data.data;

//       if (errors.length > 0) {
//         // Display error messages with line numbers
//         const errorMessages = errors.map(error => `Line ${error.lineNumber}: ${error.message}`).join(' | ');
//         setResponseMessage(`Errors: ${errorMessages}`);
//         setIsError(true); // Indicate that the message is an error
//       } else if (success.length === 0 && errors.length === 0) {
//         // No errors and no successes, show default success message
//         setResponseMessage("Submitted successfully");
//         setIsError(false); // Indicate success
//       } else {
//         // If there are any successes, show success message
//         const successMessages = success.join(' | ');
//         setResponseMessage(`Success: ${successMessages}`);
//         setIsError(false); // Indicate success
//       }
//     }

//   } catch (error) {
//     console.log(error, "error");
//     setResponseMessage("An error occurred during the file upload.");
//     setIsError(true); // Indicate error in case of exception
//   }
// };

  const handleFormSubmit = async (formData) => {
    try {
          const formDataToSend = new FormData();
          formDataToSend.append('importFileUpload', formData.uploadDocument);
              formDataToSend.append("masterMenuId",masterMenuIdValue)
              formDataToSend.append("masterSubMenuId",formData.submaster)
          console.log(formData, "uploadedDocument");
      
          const response = await axiosInstance.post("/bulkupload/importBulk", formDataToSend, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${authToken}`,
            },
          });
  
      const { errors, success } = response.data.data;
  
      // Update state with success and failed records
      setSuccessRows(success);
      setFailedRows(errors);
  
      // Success Alert
      Swal.fire({
        title: "File Uploaded",
        text: `File uploaded successfully with ${success.length} successful rows and ${errors.length} failed rows.`,
        icon: "success",
        confirmButtonText: "OK",
      });
      
    } catch (error) {
      // Error Alert
      Swal.fire({
        title: "Error",
        text: "Failed to upload file. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  const readCSVFile = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const rows = data.split('\n').map(row => row.split(','));
      setUploadedHeaders(rows[0]); // Save headers for downloading successful records
      callback(rows);
    };
    reader.readAsText(file); // Read as text for CSV
  };

  const downloadRowsCSV = (rows, headers, filename) => {
    // Ensure rows is an array of arrays
    if (!Array.isArray(rows) || !rows.every(row => Array.isArray(row))) {
      console.error("Invalid data format for CSV download:", rows);
      return;
    }

    const finalData = [headers, ...rows];
    const csvContent = finalData.map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename); // Set the download file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFailedRowsCSV = (uploadedFile, failedRows) => {
    readCSVFile(uploadedFile, (csvData) => {
      const headers = [...csvData[0], 'ErrorMessage'];

      const failedRowsData = failedRows.map(errorRow => {
        const originalRow = csvData[errorRow.lineNumber] || [];
        const errorMessage = errorRow.message || "Error";
        return [...originalRow, errorMessage]; 
      });
      downloadRowsCSV(failedRowsData, headers, 'failed_records.csv'); // Trigger download
    });
  };

  const downloadSuccessRowsCSV = (uploadedFile, successRows) => {
    readCSVFile(uploadedFile, (csvData) => {
      const headers = [...csvData[0]];

      const successRowsData = successRows.map(successRow => {
        return csvData[successRow.lineNumber] || [];
      });

      downloadRowsCSV(successRowsData, headers, 'success_records.csv'); // Trigger download
    });
  };
  const handledownload = async () => {
    const errors = {};
    let isValid = true;
    downloadInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    try {
      const payload = {
        masterMenuId: masterMenuIdValue,
        masterSubMenuId: formData.submaster,
      };
  
      const response = await axiosInstance.post("/bulkupload/download-sample", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        responseType: 'blob', // Set response type to blob for file downloads
      });
  
      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a link element
      const link = document.createElement('a');
      link.href = url;
      
      // Set the file name for the download to .csv
      link.setAttribute('download', 'sample.csv'); // Changed to .csv
      
      // Append the link to the body (required for some browsers)
      document.body.appendChild(link);
      
      // Programmatically trigger the click event on the link
      link.click();
      
      // Clean up the link after download
      document.body.removeChild(link);
  
    } catch (error) {
      console.log(error);
    }
  };

  const downloadInputs =[
    {
      name: "master",
      label: "Master Parent",
      type: "dropdown",
      options: masterOptions,
      required: true,
      gridClass: "col-lg-6",
      validation:{required:true}
    },
    {
      name: "submaster",
      label: "Master Child",
      type: "dropdown",
      options: subMasterOptions,
      required: true,
      gridClass: "col-lg-6",
      validation:{required:true}
    },
  ]
  const UploadInputs = [
  
  
    {
        name: "uploadDocument",
        label: "Bulk Upload ",
        type: "uploadFile",
        required: true,
        gridClass: "col-lg-6",
        //validation:{required:true}
      },
    ];

  return (
    <div className='p-5'>
      <div className='row downloadsamplewrapper'>
        <div className='col-lg-8'>
        <DynamicForm
          formConfig={downloadInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
        </div>
    <div className='col-lg-4'>
    <div className='downloadiconwrapperr' onClick={handledownload}>
            <a className='downloadHeading'>Download File Sample</a>
            <img src={downloadIcon} alt='download' className="downloadImg" />
          </div>
    </div>
     
      </div>
      
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "10px", alignItems: "center" }}>
        
     
        <DynamicForm
          formConfig={UploadInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "20px" }}>
         
          <button className="submit-btnn" onClick={() => handleFormSubmit(formData)} disabled={!formData.uploadDocument}>Submit</button>
          
          <div className="result-section d-flex justify-content-between gap-3">
        {successRows.length > 0 && (
          <div className="result-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ color: 'green' }}>Success Records: {successRows.length}</span>
              <img src={downloadIcon} alt='download' className="downloadImg" onClick={() => downloadSuccessRowsCSV(formData.uploadDocument, successRows)} style={{ cursor: 'pointer' }} />
            </div>
          </div>
        )}
        {failedRows.length > 0 && (
          <div className="result-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ color: 'red' }}>Failed Records: {failedRows.length}</span>
              <img src={downloadIcon} alt='download' className="downloadImg" onClick={() => downloadFailedRowsCSV(formData.uploadDocument, failedRows)} style={{ cursor: 'pointer' }} />
            </div>
          </div>
        )}
        
      </div>
     
        </div> 
       
      </div>
     
    </div>
  );
};

export default BulkUpload;
